"use client";

import Image from "next/image";

export default function FooterBrand() {
  return (
    <div className="space-y-8">
      {/* Logo */}
      <div onClick={() => window.location.href = "/"} className="inline-block cursor-pointer">
        <div className="relative w-[240px] h-[80px]">
          <Image
            src="/logo/logo.svg"
            alt="RR Equipment Rentals Logo"
            fill
            className="object-contain brightness-0 invert"
            sizes="240px"
          />
        </div>
      </div>

      {/* Modern Description */}
      <div className="space-y-4 max-w-sm">
        <p className="text-gray-300 text-lg leading-relaxed font-body">
          Professional equipment rentals across The Gold Coast.
        </p>
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-[var(--color-rr-green)] rounded-full"></div>
          <span className="text-[var(--color-rr-green)] font-semibold text-base font-body">
            Brisbane's Trusted Partner Since 2020
          </span>
        </div>
      </div>

      {/* Modern CTA */}
      <div className="space-y-4">
        <div className="text-black text-xl font-bold font-body">
          Ready to get started?
        </div>
        <button
          onClick={() => window.location.href = "/contact"}
          className="inline-flex items-center px-6 py-3 bg-[var(--color-rr-green)] text-white font-bold rounded-lg hover:bg-[var(--color-rr-green)]/90 transition-all duration-200 text-base"
        >
          Get a Quote Today
        </button>
      </div>
    </div>
  );
}
